<template>
	<div class="qkw-footer">
		<div class="pc-width">

			<div class="left">
				<div class="list">
					<div class="li" v-for="(item,index) in tabList" :key="index" @click="tiaozhuan(index)">
						{{item.name}}
					</div>
				</div>
				<div class="li">
					全国服务热线：修改电话信息
				</div>
				<div class="li">
					商务合作：修改合作信息
				</div>
				<div class="li" @click="gourl">
					© 修改备案信息
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import {
		comDetails,
		comImage
	} from "@/api/user";
	export default {
		name: 'qkw-footer',
		data() {
			return {
				tabList: [{
					name: '首页'
				}, {
					name: '关于我们'
				}, {
					name: '联系我们'
				}]
			}
		},
		methods: {
			tiaozhuan(index) {
				this.$emit('selected', index)
				localStorage.setItem('index', index)
			},
			gourl() {
				window.location.href = "https://beian.miit.gov.cn/#/Integrated/index"
			}
		}
	}
</script>

<style lang="less" scoped>
	.qkw-footer {
		background: #373737;
		padding: 40px 0;

		.pc-width {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.left {
				.list {
					font-size: 18rpx;
					font-family: PingFang SC;
					font-weight: bold;
					color: #FFFFFF;
					display: flex;

					.li {
						margin-right: 40px;
						font-size: 15rpx;
						cursor: pointer;
					}
				}

				.li {
					font-size: 16rpx;
					color: #FFFFFF;
					margin-top: 20px;
				}
			}

			.right {
				display: flex;

				.li {
					width: 150px;
					text-align: center;

					.img {
						width: 80px;
						height: 80px;
					}

					.text {
						font-size: 15rpx;
						color: #FFFFFF;
						margin-top: 10px;
					}
				}

			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/qkw-footer.vue